import React from 'react'
import { Accordion } from 'react-bootstrap'
import { MathjaxContentWrapper, MathjaxContent, MathjaxCollapsible } from 'component/Util'

const Problem = (props) => {
    return <>
        <Accordion defaultActiveKey={['Q']} alwaysOpen style={{ marginBottom: '1rem' }}>
            <Accordion.Item eventKey="Q">
                <Accordion.Header><b>Q {(props.index + 1)}</b></Accordion.Header>
                <Accordion.Body>
                    <MathjaxContent content={props.problem.question} />
                    {props.problem.hints.hints && (props.problem.hints.hints.length > 0) &&
                        props.problem.hints.hints.map((hint, index) => <MathjaxCollapsible key={index} label={`Hint ${index + 1}`} content={hint} />)
                    }
                    {props.problem.answer && <MathjaxCollapsible label={`Answer`} content={props.problem.answer} />}
                    {props.problem.solution && <MathjaxCollapsible label={`Solution`} content={props.problem.solution} />}
                    {props.problem.remarks && <MathjaxCollapsible label={`Remarks`} content={props.problem.remarks} />}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </>
}

const SectionContents = (props) => {
    return <>
        <hr />
        {props.section.title && <h5>{props.section.title}</h5>}
        {props.section.instructions && <MathjaxContent content={props.section.instructions} />}
        {Array.from({ length: props.section.end - props.section.start }, (_, i) => i + props.section.start).map((idx) =>
            <Problem key={idx} index={idx} problem={props.problems[idx]} />
        )}
    </>
}
const ProblemsetContents = (props) => {
    return <>
        {props.sections.map((section, idx) => <SectionContents key={idx} section={section} problems={props.problems} />)}
    </>
}

export const ProblemsetView = (props) => <MathjaxContentWrapper>
    <ProblemsetContents sections={props.contents.sections} problems={props.contents.problems}></ProblemsetContents>
</MathjaxContentWrapper>
